module.exports = __webpack_public_path__ + "static/media/ico-arrow-blue.dfc34b19.svg";